export default "https://cdn-static.gokick.com/assets/2d58d4130188e7931b16ced23acf41c7838443e2/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";